(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-auto-before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.ready==='true') return;
    root.dataset.ready='true';
    var frame=root.querySelector('[data-rc-auto-frame]');
    var range=root.querySelector('[data-rc-auto-range]');
    var before=root.querySelector('[data-rc-auto-before]');
    var after=root.querySelector('[data-rc-auto-after]');
    var choices=[].slice.call(root.querySelectorAll('.rc-auto-ba__choice'));
    if(!frame||!range||!before||!after) return;

    function setSplit(value){
      var n=Math.max(0,Math.min(100,Number(value)||50));
      frame.style.setProperty('--rc-auto-split',n+'%');
      range.value=n;
    }

    range.addEventListener('input',function(){setSplit(range.value);});
    range.addEventListener('change',function(){setSplit(range.value);});

    choices.forEach(function(btn){
      btn.addEventListener('click',function(){
        choices.forEach(function(other){
          var active=other===btn;
          other.classList.toggle('is-active',active);
          other.setAttribute('aria-pressed',active?'true':'false');
        });
        var b=btn.dataset.before;
        var a=btn.dataset.after;
        var label=btn.dataset.label||'véhicule';
        if(b) before.src=b;
        if(a) after.src=a;
        before.alt=label+' avant transformation';
        after.alt=label+' transformé en découpe laser';
        setSplit(50);
      });
    });

    setSplit(50);
  }

  function boot(){document.querySelectorAll('[data-rc-auto-ba]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const section=document.querySelector('[data-rc-collection-section]');
    if(!section||section.dataset.controlsReady==='true')return;
    section.dataset.controlsReady='true';
    const drawer=section.querySelector('#RcFilterDrawer'),backdrop=section.querySelector('.rc-filter-backdrop'),openButton=section.querySelector('[data-rc-filter-open]'),closeButtons=section.querySelectorAll('[data-rc-filter-close]'),sortSelect=section.querySelector('[data-rc-sort]');
    const close=()=>{if(!drawer||!backdrop)return;drawer.classList.remove('is-open');backdrop.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');if(openButton)openButton.setAttribute('aria-expanded','false');document.body.classList.remove('rc-filter-lock');setTimeout(()=>{if(!backdrop.classList.contains('is-open'))backdrop.hidden=true},230)};
    const open=()=>{if(!drawer||!backdrop)return;backdrop.hidden=false;requestAnimationFrame(()=>{drawer.classList.add('is-open');backdrop.classList.add('is-open')});drawer.setAttribute('aria-hidden','false');if(openButton)openButton.setAttribute('aria-expanded','true');document.body.classList.add('rc-filter-lock')};
    if(openButton)openButton.addEventListener('click',open);closeButtons.forEach(b=>b.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer&&drawer.classList.contains('is-open'))close()});
    if(sortSelect)sortSelect.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('sort_by',sortSelect.value);url.searchParams.delete('page');location.assign(url.toString())});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  var pendingKey='rcAccountSignupPending';
  var verifiedKey='rcAccountVerifiedUntil';
  var marketingKey='rcMarketingState';
  var form=document.getElementById('RCNewsletterForm');
  var marketingForm=document.getElementById('RCMarketingOptInForm');
  if(!form)return;

  function safeGet(key){try{return sessionStorage.getItem(key)}catch(e){return null}}
  function safeSet(key,value){try{sessionStorage.setItem(key,String(value))}catch(e){}}
  function safeRemove(key){try{sessionStorage.removeItem(key)}catch(e){}}
  function readPending(){try{return JSON.parse(safeGet(pendingKey)||'null')}catch(e){return null}}
  function currentPreviewId(){return new URLSearchParams(window.location.search).get('preview_theme_id')||((readPending()||{}).previewId||'')}
  function currentReturnTo(){
    var raw=new URLSearchParams(window.location.search).get('return_to')||((readPending()||{}).returnTo||'');
    if(!raw||raw.charAt(0)!=='/'||raw.indexOf('//')===0)return '';
    return raw;
  }
  function finalReturnPath(previewId){
    var target=currentReturnTo();
    if(target){
      var sep=target.indexOf('?')>=0?'&':'?';
      target+=sep+'auction_setup=1';
      if(previewId)target+='&preview_theme_id='+encodeURIComponent(previewId);
      return target;
    }
    var path='/?rc_signup_complete=1';
    if(previewId)path+='&preview_theme_id='+encodeURIComponent(previewId);
    return path;
  }
  function buildAccountUrl(email,previewId){var url='/customer_authentication/login?return_to='+encodeURIComponent(finalReturnPath(previewId));if(email)url+='&login_hint='+encodeURIComponent(email);return url}
  function redirectToAccount(pending){window.location.assign(buildAccountUrl((pending||{}).email||'',(pending||{}).previewId||currentPreviewId()))}

  var finalTemplate=document.getElementById('RCAccountSuccessTemplate');
  var params=new URLSearchParams(window.location.search);
  if(params.get('rc_signup_complete')==='1'){
    var finished=readPending();
    safeSet(verifiedKey,Date.now()+600000);
    if(finished&&!finished.marketing)safeSet(marketingKey,'0');
    if(finalTemplate)form.innerHTML=finalTemplate.innerHTML;
    safeRemove(pendingKey);
    return;
  }

  if(document.querySelector('[data-rc-marketing-saved]')){
    var subscribedPending=readPending()||{};
    safeSet(marketingKey,'1');
    window.setTimeout(function(){redirectToAccount(subscribedPending)},100);
    return;
  }

  if(document.querySelector('[data-rc-marketing-error]')){
    var failedPending=readPending()||{};
    safeSet(marketingKey,'0');
    window.setTimeout(function(){redirectToAccount(failedPending)},100);
    return;
  }

  var tagsInput=document.getElementById('RCNewsletterTags');
  var emailOptIn=document.getElementById('RCEmailOptIn');
  var foundOtherToggle=document.getElementById('RCFoundUsOtherToggle');
  var interestsOtherToggle=document.getElementById('RCInterestsOtherToggle');
  var foundOtherWrap=document.getElementById('RCFoundUsOtherWrap');
  var interestsOtherWrap=document.getElementById('RCInterestsOtherWrap');
  var foundOtherInput=document.getElementById('RCFoundUsOther');
  var interestsOtherInput=document.getElementById('RCInterestsOther');
  var foundChoices=Array.prototype.slice.call(form.querySelectorAll('.rc-tag-choice[data-group="found"]'));
  var interestChoices=Array.prototype.slice.call(form.querySelectorAll('.rc-tag-choice[data-group="interests"]'));
  if(!tagsInput||!emailOptIn||!foundOtherToggle||!interestsOtherToggle||!foundOtherWrap||!interestsOtherWrap||!foundOtherInput||!interestsOtherInput)return;

  var foundError=document.createElement('div');
  foundError.className='rc-newsletter-error';
  foundError.textContent='Choisissez au moins une option pour nous dire comment vous avez trouvé Rustique Chic.';
  foundOtherWrap.parentNode.insertBefore(foundError,foundOtherWrap.nextSibling);
  var interestsError=document.createElement('div');
  interestsError.className='rc-newsletter-error';
  interestsError.textContent='Choisissez au moins un centre d’intérêt.';
  interestsOtherWrap.parentNode.insertBefore(interestsError,interestsOtherWrap.nextSibling);

  function cleanCustom(value){return(value||'').replace(/,/g,' ').replace(/\s+/g,' ').trim().slice(0,60)}
  function groupHasChecked(choices){return choices.some(function(choice){return choice.checked})}
  function updateOtherField(toggle,wrap,input){var active=!!(toggle&&toggle.checked);if(active){wrap.hidden=false;input.required=true;window.requestAnimationFrame(function(){wrap.classList.add('is-visible')});return}wrap.classList.remove('is-visible');input.required=false;input.value='';input.setCustomValidity('');window.setTimeout(function(){if(!wrap.classList.contains('is-visible'))wrap.hidden=true},280)}
  function addChoiceTags(tags,choices){choices.forEach(function(choice){if(choice.checked&&choice.value.indexOf('__other_')!==0)tags.push(choice.value)})}
  function updateTags(){var tags=['newsletter'];addChoiceTags(tags,foundChoices);if(foundOtherToggle.checked){var foundOther=cleanCustom(foundOtherInput.value);if(foundOther)tags.push('Source: Autre - '+foundOther)}addChoiceTags(tags,interestChoices);if(interestsOtherToggle.checked){var interestOther=cleanCustom(interestsOtherInput.value);if(interestOther)tags.push('Intérêt: Autre - '+interestOther)}tagsInput.value=tags.join(', ')}
  function refresh(){updateOtherField(foundOtherToggle,foundOtherWrap,foundOtherInput);updateOtherField(interestsOtherToggle,interestsOtherWrap,interestsOtherInput);foundError.classList.remove('is-visible');interestsError.classList.remove('is-visible');updateTags()}
  function validateOther(toggle,input){if(toggle.checked&&!cleanCustom(input.value)){input.setCustomValidity('Veuillez préciser votre réponse.');return false}input.setCustomValidity('');return true}
  function animateForRedirect(callback){form.classList.add('is-submitting');var submitButton=form.querySelector('[type="submit"]');if(submitButton)submitButton.disabled=true;var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;window.setTimeout(callback,reduceMotion?20:240)}

  foundChoices.concat(interestChoices,[foundOtherInput,interestsOtherInput]).forEach(function(element){element.addEventListener('change',refresh);element.addEventListener('input',refresh)});

  form.addEventListener('submit',function(event){
    event.preventDefault();
    refresh();
    if(!form.checkValidity()){form.reportValidity();return}
    var validFoundGroup=groupHasChecked(foundChoices);
    var validInterestGroup=groupHasChecked(interestChoices);
    var validFoundOther=validateOther(foundOtherToggle,foundOtherInput);
    var validInterestOther=validateOther(interestsOtherToggle,interestsOtherInput);
    updateTags();
    if(!validFoundGroup||!validInterestGroup||!validFoundOther||!validInterestOther){
      if(!validFoundGroup)foundError.classList.add('is-visible');
      if(!validInterestGroup)interestsError.classList.add('is-visible');
      if(!validFoundGroup&&foundChoices[0])foundChoices[0].focus();
      else if(!validFoundOther)foundOtherInput.reportValidity();
      else if(!validInterestGroup&&interestChoices[0])interestChoices[0].focus();
      else if(!validInterestOther)interestsOtherInput.reportValidity();
      return;
    }

    var email=(document.getElementById('RCNewsletterEmail')||{}).value||'';
    var name=(document.getElementById('RCNewsletterFullName')||{}).value||'';
    var note=(document.getElementById('RCNewsletterMessage')||{}).value||'';
    var pending={email:email.trim(),name:name.trim(),marketing:!!emailOptIn.checked,tags:tagsInput.value,note:note.trim(),previewId:currentPreviewId(),returnTo:currentReturnTo()};
    safeSet(pendingKey,JSON.stringify(pending));

    if(emailOptIn.checked&&marketingForm){
      safeSet(marketingKey,'0');
      var mEmail=document.getElementById('RCMarketingEmail');
      var mName=document.getElementById('RCMarketingName');
      var mTags=document.getElementById('RCMarketingTags');
      var mNote=document.getElementById('RCMarketingNote');
      if(mEmail)mEmail.value=pending.email;
      if(mName)mName.value=pending.name;
      if(mTags)mTags.value=pending.tags;
      if(mNote)mNote.value=pending.note;
      form.classList.add('is-submitting');
      marketingForm.submit();
      return;
    }

    safeSet(marketingKey,'0');
    animateForRedirect(function(){redirectToAccount(pending)});
  });

  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-home"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rc-home-slider]').forEach((slider)=>{if(slider.dataset.rcSliderReady==='true')return;slider.dataset.rcSliderReady='true';const track=slider.querySelector('.rc-hero-slider__track');const slides=[...slider.querySelectorAll('[data-rc-slide]')];const dots=[...slider.querySelectorAll('[data-rc-dot]')];const prev=slider.querySelector('[data-rc-prev]');const next=slider.querySelector('[data-rc-next]');if(!track||slides.length<2)return;let index=0;let timer=null;let touchStartX=null;const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;const show=(i)=>{index=(i+slides.length)%slides.length;track.style.transform='translate3d('+(-index*100)+'%,0,0)';slides.forEach((s,n)=>{s.classList.toggle('is-active',n===index);s.setAttribute('aria-hidden',n===index?'false':'true')});dots.forEach((d,n)=>{const active=n===index;d.classList.toggle('is-active',active);if(active)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current')})};const stop=()=>{if(timer){clearInterval(timer);timer=null}};const start=()=>{stop();if(!reduced)timer=setInterval(()=>show(index+1),3000)};prev&&prev.addEventListener('click',()=>{show(index-1);start()});next&&next.addEventListener('click',()=>{show(index+1);start()});dots.forEach(d=>d.addEventListener('click',()=>{show(Number(d.dataset.rcDot)||0);start()}));slider.addEventListener('mouseenter',stop);slider.addEventListener('mouseleave',start);slider.addEventListener('focusin',stop);slider.addEventListener('focusout',start);slider.addEventListener('touchstart',(e)=>{touchStartX=e.touches&&e.touches[0]?e.touches[0].clientX:null;stop()},{passive:true});slider.addEventListener('touchend',(e)=>{if(touchStartX!==null&&e.changedTouches&&e.changedTouches[0]){const dx=e.changedTouches[0].clientX-touchStartX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1))}touchStartX=null;start()},{passive:true});show(0);start()});document.querySelectorAll('.rc-home').forEach((home)=>{if(home.dataset.enhanced==='true')return;home.dataset.enhanced='true';const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const items=home.querySelectorAll('.rc-reveal');let observer;if(reducedMotion||!('IntersectionObserver'in window)){items.forEach(i=>i.classList.add('is-visible'))}else{observer=new IntersectionObserver((entries,o)=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');o.unobserve(e.target)}}),{threshold:.12});items.forEach(i=>observer.observe(i))}const buttons=home.querySelectorAll('[data-filter]');const cards=home.querySelectorAll('.rc-card');const applyFilter=(filter)=>{buttons.forEach(b=>{const active=b.dataset.filter===filter;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',active?'true':'false')});cards.forEach(card=>{const show=filter==='all'||card.dataset.category===filter;card.hidden=!show;if(show&&!reducedMotion){card.classList.add('is-visible')}})};buttons.forEach(b=>b.addEventListener('click',()=>applyFilter(b.dataset.filter)));applyFilter('nature-faune-plein-air')});document.querySelectorAll('[data-rc-decor-scroll]').forEach((scene)=>{if(scene.dataset.ready)return;scene.dataset.ready='1';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const cutout=scene.querySelector('[data-rc-cutout]');const canvas=cutout&&cutout.querySelector('canvas');if(cutout&&canvas){const source=cutout.dataset.source;const img=new Image();img.crossOrigin='anonymous';img.onload=()=>{const sw=img.naturalWidth,sh=img.naturalHeight;const sx=Math.round(sw*.12),sy=Math.round(sh*.18),cw=Math.round(sw*.76),ch=Math.round(sh*.34);const maxW=1100,scale=Math.min(1,maxW/cw),w=Math.max(1,Math.round(cw*scale)),h=Math.max(1,Math.round(ch*scale));canvas.width=w;canvas.height=h;const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,sx,sy,cw,ch,0,0,w,h);const im=ctx.getImageData(0,0,w,h),p=im.data;for(let i=0;i<p.length;i+=4){const lum=.2126*p[i]+.7152*p[i+1]+.0722*p[i+2];let a=0;if(lum<48)a=255;else if(lum<78)a=Math.round((78-lum)/30*255);p[i]=15;p[i+1]=15;p[i+2]=14;p[i+3]=a}ctx.clearRect(0,0,w,h);ctx.putImageData(im,0,0)};img.onerror=()=>{cutout.style.display='none'};img.src=source+(source.includes('?')?'&':'?')+'width=1200'}if(reduced){scene.style.setProperty('--rc-decor-progress','1');scene.style.setProperty('--rc-text-progress','1');return}let current=0,target=0,raf=0;const computeTarget=()=>{const rect=scene.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;target=Math.min(1,Math.max(0,(vh*.97-rect.top)/(vh*.95)))};const tick=()=>{const delta=target-current;current+=delta*.045;if(Math.abs(delta)<.0015)current=target;const eased=current*current*(3-2*current);const tr=Math.min(1,Math.max(0,(current-.08)/.84));const te=tr*tr*(3-2*tr);scene.style.setProperty('--rc-decor-progress',eased.toFixed(4));scene.style.setProperty('--rc-text-progress',te.toFixed(4));if(Math.abs(target-current)>.0015){raf=requestAnimationFrame(tick)}else{raf=0}};const update=()=>{computeTarget();if(!raf)raf=requestAnimationFrame(tick)};window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});computeTarget();current=target;scene.style.setProperty('--rc-decor-progress',(current*current*(3-2*current)).toFixed(4));const tr=Math.min(1,Math.max(0,(current-.08)/.84));scene.style.setProperty('--rc-text-progress',(tr*tr*(3-2*tr)).toFixed(4))});document.querySelectorAll('[data-rc-story-scroll]').forEach((scene)=>{if(scene.dataset.storyReady)return;scene.dataset.storyReady='1';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;if(reduced){scene.style.setProperty('--rc-story-progress','1');scene.style.setProperty('--rc-story-text','1');return}let current=0,target=0,raf=0;const compute=()=>{const rect=scene.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;target=Math.min(1,Math.max(0,(vh*.96-rect.top)/(vh*.92)))};const tick=()=>{const delta=target-current;current+=delta*.05;if(Math.abs(delta)<.0015)current=target;const p=current*current*(3-2*current);const tr=Math.min(1,Math.max(0,(current-.08)/.84));const tp=tr*tr*(3-2*tr);scene.style.setProperty('--rc-story-progress',p.toFixed(4));scene.style.setProperty('--rc-story-text',tp.toFixed(4));if(Math.abs(target-current)>.0015)raf=requestAnimationFrame(tick);else raf=0};const update=()=>{compute();if(!raf)raf=requestAnimationFrame(tick)};window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});compute();current=target;const p=current*current*(3-2*current);const tr=Math.min(1,Math.max(0,(current-.08)/.84));scene.style.setProperty('--rc-story-progress',p.toFixed(4));scene.style.setProperty('--rc-story-text',(tr*tr*(3-2*tr)).toFixed(4))});document.querySelectorAll('[data-rc-duo-card]').forEach((card)=>{if(card.dataset.rcDuoReady)return;card.dataset.rcDuoReady='1';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const cutout=card.querySelector('[data-rc-duo-cutout]');const canvas=cutout&&cutout.querySelector('canvas');if(cutout&&canvas){const src=cutout.dataset.source;const crop=(cutout.dataset.crop||'0,0,1,1').split(',').map(Number);const solid=Number(cutout.dataset.solid||52),fade=Number(cutout.dataset.fade||92);const img=new Image();img.crossOrigin='anonymous';img.onload=()=>{const sw=img.naturalWidth,sh=img.naturalHeight;const sx=Math.round(sw*crop[0]),sy=Math.round(sh*crop[1]),cw=Math.round(sw*crop[2]),ch=Math.round(sh*crop[3]);const maxW=1100,scale=Math.min(1,maxW/cw),w=Math.max(1,Math.round(cw*scale)),h=Math.max(1,Math.round(ch*scale));canvas.width=w;canvas.height=h;const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(img,sx,sy,cw,ch,0,0,w,h);const im=ctx.getImageData(0,0,w,h),p=im.data;for(let i=0;i<p.length;i+=4){const lum=.2126*p[i]+.7152*p[i+1]+.0722*p[i+2];let a=0;if(lum<solid)a=255;else if(lum<fade)a=Math.round((fade-lum)/(fade-solid)*255);p[i]=15;p[i+1]=15;p[i+2]=14;p[i+3]=a}ctx.clearRect(0,0,w,h);ctx.putImageData(im,0,0)};img.onerror=()=>{cutout.style.display='none'};img.src=src+(src.includes('?')?'&':'?')+'width=1200'}if(reduced){card.style.setProperty('--rc-card-progress','1');card.style.setProperty('--rc-card-text','1');return}let current=0,target=0,raf=0;const compute=()=>{const rect=card.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;target=Math.min(1,Math.max(0,(vh*.95-rect.top)/(vh*.95)))};const tick=()=>{const delta=target-current;current+=delta*.05;if(Math.abs(delta)<.0015)current=target;const p=current*current*(3-2*current);const tr=Math.min(1,Math.max(0,(current-.10)/.82));const tp=tr*tr*(3-2*tr);card.style.setProperty('--rc-card-progress',p.toFixed(4));card.style.setProperty('--rc-card-text',tp.toFixed(4));if(Math.abs(target-current)>.0015)raf=requestAnimationFrame(tick);else raf=0};const update=()=>{compute();if(!raf)raf=requestAnimationFrame(tick)};window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});compute();current=target;const p=current*current*(3-2*current);const tr=Math.min(1,Math.max(0,(current-.10)/.82));card.style.setProperty('--rc-card-progress',p.toFixed(4));card.style.setProperty('--rc-card-text',(tr*tr*(3-2*tr)).toFixed(4))});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rc-product]').forEach(function(root){
  var productForm=root.querySelector('.rc-product__form');
  var personalization=root.querySelector('[data-rc-personalization]');
  var personalizationWrap=root.querySelector('[data-rc-personalization-wrap]');
  var personalizationCount=root.querySelector('[data-rc-personalization-count]');
  var personalizationError=root.querySelector('[data-rc-personalization-error]');

  var imageInput=root.querySelector('[data-rc-image-input]');
  var imageWrap=root.querySelector('[data-rc-image-upload-wrap]');
  var imageDropzone=root.querySelector('[data-rc-image-dropzone]');
  var imageEmpty=root.querySelector('[data-rc-image-empty]');
  var imagePreviewWrap=root.querySelector('[data-rc-image-preview-wrap]');
  var imagePreview=root.querySelector('[data-rc-image-preview]');
  var imageFilename=root.querySelector('[data-rc-image-filename]');
  var imageActions=root.querySelector('[data-rc-image-actions]');
  var imageRemove=root.querySelector('[data-rc-image-remove]');
  var imageError=root.querySelector('[data-rc-image-error]');
  var previewUrl='';

  function personalizationValue(){
    return personalization ? personalization.value.trim() : '';
  }

  function showPersonalizationError(){
    if(!personalization||!personalizationWrap)return;
    personalizationWrap.classList.add('is-invalid');
    personalization.setAttribute('aria-invalid','true');
    if(personalizationError)personalizationError.hidden=false;
  }

  function clearPersonalizationError(){
    if(!personalization||!personalizationWrap)return;
    personalizationWrap.classList.remove('is-invalid');
    personalization.removeAttribute('aria-invalid');
    if(personalizationError)personalizationError.hidden=true;
  }

  if(personalization){
    var maxLength=Number(personalization.getAttribute('maxlength')||60);
    function updatePersonalization(){
      if(personalizationCount)personalizationCount.textContent=personalization.value.length+' / '+maxLength;
      if(personalizationValue())clearPersonalizationError();
    }
    personalization.addEventListener('input',updatePersonalization);
    personalization.addEventListener('invalid',function(event){
      event.preventDefault();
      showPersonalizationError();
    });
    updatePersonalization();
  }

  function imageSelected(){
    return !!(imageInput&&imageInput.files&&imageInput.files.length);
  }

  function showImageError(message){
    if(!imageWrap)return;
    imageWrap.classList.add('is-invalid');
    if(imageInput)imageInput.setAttribute('aria-invalid','true');
    if(imageError){
      if(message)imageError.textContent=message;
      imageError.hidden=false;
    }
  }

  function clearImageError(){
    if(!imageWrap)return;
    imageWrap.classList.remove('is-invalid');
    if(imageInput)imageInput.removeAttribute('aria-invalid');
    if(imageError){
      imageError.textContent='Veuillez ajouter une image de référence avant d’ajouter ce produit au panier.';
      imageError.hidden=true;
    }
  }

  function clearPreview(){
    if(previewUrl){URL.revokeObjectURL(previewUrl);previewUrl='';}
    if(imagePreview){imagePreview.removeAttribute('src');}
    if(imagePreviewWrap)imagePreviewWrap.hidden=true;
    if(imageEmpty)imageEmpty.hidden=false;
    if(imageActions)imageActions.hidden=true;
    if(imageFilename)imageFilename.textContent='';
  }

  function renderImageFile(file){
    if(!file){clearPreview();return;}
    if(!file.type||file.type.indexOf('image/')!==0){
      if(imageInput)imageInput.value='';
      clearPreview();
      showImageError('Veuillez choisir un fichier image valide.');
      return;
    }
    clearImageError();
    if(previewUrl)URL.revokeObjectURL(previewUrl);
    previewUrl=URL.createObjectURL(file);
    if(imagePreview){imagePreview.src=previewUrl;}
    if(imageFilename)imageFilename.textContent=file.name;
    if(imagePreviewWrap)imagePreviewWrap.hidden=false;
    if(imageEmpty)imageEmpty.hidden=true;
    if(imageActions)imageActions.hidden=false;
  }

  if(imageInput){
    imageInput.addEventListener('change',function(){
      renderImageFile(imageInput.files&&imageInput.files[0]);
    });
    imageInput.addEventListener('invalid',function(event){
      event.preventDefault();
      showImageError();
    });
  }

  if(imageDropzone){
    ['dragenter','dragover'].forEach(function(type){
      imageDropzone.addEventListener(type,function(event){
        event.preventDefault();
        event.stopPropagation();
        imageDropzone.classList.add('is-dragging');
      });
    });
    ['dragleave','dragend'].forEach(function(type){
      imageDropzone.addEventListener(type,function(){imageDropzone.classList.remove('is-dragging');});
    });
    imageDropzone.addEventListener('drop',function(event){
      event.preventDefault();
      event.stopPropagation();
      imageDropzone.classList.remove('is-dragging');
      var files=event.dataTransfer&&event.dataTransfer.files;
      var file=files&&files[0];
      if(!file)return;
      if(!file.type||file.type.indexOf('image/')!==0){
        showImageError('Veuillez déposer un fichier image valide.');
        return;
      }
      try{
        var transfer=new DataTransfer();
        transfer.items.add(file);
        imageInput.files=transfer.files;
      }catch(e){
        imageInput.click();
        return;
      }
      renderImageFile(file);
    });
  }

  if(imageRemove){
    imageRemove.addEventListener('click',function(event){
      event.preventDefault();
      if(imageInput)imageInput.value='';
      clearPreview();
      clearImageError();
    });
  }

  if(productForm){
    productForm.addEventListener('submit',function(event){
      var invalidTarget=null;
      if(personalization&&!personalizationValue()){
        showPersonalizationError();
        invalidTarget=personalizationWrap||personalization;
      }
      if(imageInput&&!imageSelected()){
        showImageError();
        if(!invalidTarget)invalidTarget=imageWrap||imageDropzone;
      }
      if(invalidTarget){
        event.preventDefault();
        event.stopPropagation();
        if(invalidTarget.scrollIntoView)invalidTarget.scrollIntoView({behavior:'smooth',block:'center'});
        if(personalization&&!personalizationValue())personalization.focus({preventScroll:true});
      }
    },true);
  }

  var select=root.querySelector('[data-rc-variant-select]');
  if(!select)return;

  var price=root.querySelector('[data-rc-price]');
  var add=root.querySelector('[data-rc-add]');
  var isNFL=root.hasAttribute('data-rc-nfl-product');
  var mainImage=root.querySelector('[data-rc-nfl-main],[data-rc-gallery-main]');
  var thumbs=Array.from(root.querySelectorAll('[data-rc-nfl-thumb],[data-rc-gallery-thumb]'));
  var payment=root.querySelector('[data-rc-payment]');

  var collageSrc=isNFL&&mainImage?mainImage.currentSrc||mainImage.src:'';
  var collageAlt=isNFL&&mainImage?mainImage.alt:'';

  function money(cents){
    try{
      return new Intl.NumberFormat('fr-CA',{style:'currency',currency:'CAD'}).format(cents/100);
    }catch(e){
      return (cents/100).toFixed(2)+' $';
    }
  }

  function setMain(src,alt,mediaId){
    if(!mainImage||!src)return;
    mainImage.style.opacity='.35';
    var preload=new Image();
    preload.onload=function(){
      mainImage.removeAttribute('srcset');
      mainImage.src=src;
      if(alt)mainImage.alt=alt;
      mainImage.style.opacity='1';
      thumbs.forEach(function(thumb){
        var active=!!mediaId&&thumb.dataset.mediaId===mediaId;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-pressed',active?'true':'false');
      });
    };
    preload.onerror=function(){mainImage.style.opacity='1';};
    preload.src=src;
  }

  function update(){
    var option=select.options[select.selectedIndex];
    var hasChoice=!!(option&&option.value);
    var cents=Number(option&&option.dataset.price||0);
    var available=hasChoice&&option.dataset.available==='true';

    if(price&&cents)price.textContent=money(cents);

    if(add){
      add.disabled=!available;
      add.textContent=!hasChoice?(isNFL?'Choisir une équipe':'Indisponible'):(available?'Ajouter au panier':'Épuisé');
    }

    if(isNFL){
      if(payment)payment.hidden=!hasChoice;
      thumbs.forEach(function(thumb){thumb.hidden=hasChoice&&thumb.dataset.variantId===option.value;});
      if(hasChoice&&option.dataset.imageUrl){
        setMain(option.dataset.imageUrl,option.dataset.imageAlt||option.textContent.trim(),option.dataset.mediaId);
      }else if(collageSrc){
        setMain(collageSrc,collageAlt,'');
      }
    }else if(hasChoice&&option.dataset.imageUrl){
      setMain(option.dataset.imageUrl,option.dataset.imageAlt||option.textContent.trim(),option.dataset.mediaId);
    }

    if(hasChoice){
      var url=new URL(window.location.href);
      url.searchParams.set('variant',option.value);
      history.replaceState({},'',url.toString());
    }
  }

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click',function(){
      var src=thumb.dataset.fullImage;
      setMain(src,thumb.dataset.imageAlt||'',thumb.dataset.mediaId||'');
      var variantId=thumb.dataset.variantId;
      if(variantId){
        select.value=variantId;
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }
    });
  });

  select.addEventListener('change',update);
  update();
});

document.querySelectorAll('[data-rc-auto-slider]').forEach(function(slider){
  if(slider.dataset.ready==='true')return;
  slider.dataset.ready='true';
  var stage=slider.querySelector('[data-rc-auto-stage]');
  var range=slider.querySelector('[data-rc-auto-range]');
  var before=slider.querySelector('[data-rc-auto-before]');
  var after=slider.querySelector('[data-rc-auto-after]');
  var models=Array.from(slider.querySelectorAll('.rc-auto-slider__model'));
  var raf=0;
  if(!stage||!range||!before||!after)return;

  function setSplit(value){
    var n=Math.max(0,Math.min(100,Number(value)));
    if(!isFinite(n))n=50;
    cancelAnimationFrame(raf);
    raf=requestAnimationFrame(function(){
      stage.style.setProperty('--split',n+'%');
      range.value=String(n);
    });
  }

  range.addEventListener('input',function(){setSplit(range.value);});
  range.addEventListener('change',function(){setSplit(range.value);});

  function swapImages(btn){
    var nextBefore=btn.dataset.before;
    var nextAfter=btn.dataset.after;
    var name=btn.dataset.name||'Véhicule';
    if(!nextBefore||!nextAfter)return;

    stage.classList.add('is-switching');
    var a=new Image();
    var b=new Image();
    var ready=0;
    function done(){
      ready+=1;
      if(ready<2)return;
      before.src=nextBefore;
      after.src=nextAfter;
      before.alt=name+' avant transformation';
      after.alt=name+' après transformation';
      requestAnimationFrame(function(){
        stage.classList.remove('is-switching');
        setSplit(50);
      });
    }
    a.onload=done;a.onerror=done;a.src=nextBefore;
    b.onload=done;b.onerror=done;b.src=nextAfter;
  }

  models.forEach(function(btn){
    btn.addEventListener('click',function(){
      if(btn.classList.contains('is-active'))return;
      models.forEach(function(other){
        var active=other===btn;
        other.classList.toggle('is-active',active);
        other.setAttribute('aria-pressed',active?'true':'false');
      });
      swapImages(btn);
      try{btn.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}catch(e){}
    });
  });

  setSplit(50);
});


document.querySelectorAll('[data-rc-auto-examples]').forEach(function(root){
  if(root.dataset.examplesReady==='true')return;
  root.dataset.examplesReady='true';
  var toggle=root.querySelector('[data-rc-auto-examples-toggle]');
  var close=root.querySelector('[data-rc-auto-examples-close]');
  if(!toggle)return;
  function setOpen(open){
    root.classList.toggle('is-open',open);
    toggle.setAttribute('aria-expanded',open?'true':'false');
    if(!open){
      try{toggle.scrollIntoView({behavior:'smooth',block:'nearest'});}catch(e){}
    }
  }
  toggle.addEventListener('click',function(){setOpen(!root.classList.contains('is-open'));});
  if(close)close.addEventListener('click',function(){setOpen(false);});
});


document.querySelectorAll('[data-rc-auto-examples]').forEach(function(root){
  if(root.dataset.lightboxReady==='true')return;
  root.dataset.lightboxReady='true';

  var lightbox=root.querySelector('[data-rc-auto-lightbox]');
  var image=lightbox&&lightbox.querySelector('[data-rc-auto-lightbox-image]');
  var caption=lightbox&&lightbox.querySelector('[data-rc-auto-lightbox-caption]');
  var openers=Array.from(root.querySelectorAll('[data-rc-auto-example-open]'));
  var closers=lightbox?Array.from(lightbox.querySelectorAll('[data-rc-auto-lightbox-close]')):[];
  var lastFocus=null;

  function openLightbox(btn){
    if(!lightbox||!image)return;
    lastFocus=btn;
    image.src=btn.dataset.src||'';
    image.alt=btn.dataset.alt||'Exemple avant et après';
    if(caption)caption.textContent=btn.dataset.title||'Exemple';
    lightbox.hidden=false;
    document.documentElement.style.overflow='hidden';
    var close=lightbox.querySelector('.rc-auto-lightbox__close');
    if(close)close.focus({preventScroll:true});
  }

  function closeLightbox(){
    if(!lightbox||lightbox.hidden)return;
    lightbox.hidden=true;
    document.documentElement.style.overflow='';
    image.removeAttribute('src');
    if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});
  }

  openers.forEach(function(btn){
    btn.addEventListener('click',function(){openLightbox(btn);});
  });
  closers.forEach(function(btn){
    btn.addEventListener('click',closeLightbox);
  });
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&lightbox&&!lightbox.hidden)closeLightbox();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-rating"]) return;
  try {
    
(function(){
  function mountRustiqueRating(){
    document.querySelectorAll('[data-rc-rating-mount]').forEach(function(mount){
      if(mount.dataset.mounted==='true')return;
      var details=document.querySelector('.rc-product__details');
      var price=details&&details.querySelector('.rc-product__price');
      if(!details||!price)return;
      price.parentNode.insertBefore(mount,price);
      mount.classList.add('is-mounted');
      mount.dataset.mounted='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountRustiqueRating);
  else mountRustiqueRating();
  document.addEventListener('shopify:section:load',mountRustiqueRating);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rustique-chic-reviews"]) return;
  try {
    
(function(){
  function setupRustiqueReviews(section){
    if(!section||section.dataset.rcReviewsBound==='true')return;
    var widget=section.querySelector('[data-rc-reviews-widget]');
    var toggle=section.querySelector('[data-rc-reviews-toggle]');
    var toggleText=section.querySelector('[data-rc-reviews-toggle-text]');
    if(!widget||!toggle||!toggleText)return;

    section.dataset.rcReviewsBound='true';

    function refreshToggle(){
      var body=widget.querySelector('.jdgm-rev-widg__body');
      toggle.hidden=!body;
    }

    toggle.addEventListener('click',function(){
      var expanded=section.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded',expanded?'true':'false');
      toggleText.textContent=expanded?'Masquer les avis':'Voir les avis';
    });

    var observer=new MutationObserver(refreshToggle);
    observer.observe(widget,{childList:true,subtree:true});
    refreshToggle();
  }

  function initRustiqueReviews(){
    document.querySelectorAll('[data-rc-reviews]').forEach(setupRustiqueReviews);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRustiqueReviews);
  else initRustiqueReviews();
  document.addEventListener('shopify:section:load',initRustiqueReviews);
})();

  } catch(e) { console.error(e); }
})();
})();
